import { ArquivoService } from './../../../../services/arquivo.service';
import { AtaReuniaoService } from './../../../../services/ata-reuniao.service';
import { Departamento } from './../../cadastros/cadastro-equipe/cadastro-equipe.component';
import { EquipeService } from './../../../../services/equipe.service';
import { AfterViewInit, Component, Inject, NgZone } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormValidations } from '../../../../services/form-validations'
import { LoginService } from '../../../../services/login.service';
import { AtendimentoSolicitacaoService } from '../../../../services/atendimento-solicitacao.service';
import { AtendimentoDependenciaComponent } from './atendimento-dependencia/atendimento-dependencia.component'
import { PesquisaComponent } from '../pesquisa/pesquisa.component';
import { PaginaPerguntaComponent } from '../pagina-pergunta/pagina-pergunta.component';
import { ClienteService } from '../../../../services/cliente.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { PaginaErroComponent } from '../pagina-erro/pagina-erro.component';
import { UploadAtendimentoService } from '../../../../services/upload-atendimento.service';
import { PaginaEsperaComponent } from '../pagina-espera/pagina-espera.component';
import { ConsultaSolicitacoesService } from '../../../../services/consulta-solicitacoes.service';
import { SolucaoTarefaComponent } from '../solucao-tarefa/solucao-tarefa.component';
import { FecharSolicitacaoComponent } from './fechar-solicitacao/fechar-solicitacao.component';
import { GeradorPdfComponent } from '../gerador-pdf/gerador-pdf.component';
import { HistoricoConversaComponent } from '../../atendimento-whatsapp/historico-conversa/historico-conversa.component';
import { ChatService } from '../../../../services/chat.service';
import { NbIconLibraries } from '@nebular/theme';
import { personalizedIcons } from '../../atendimento-whatsapp/chat/svgDocIcons';
import { ParametrosService } from '../../../../services/parametros.service';
import { PaginaStatusComponent } from '../pagina-status/pagina-status.component';
import { AlteraStatusInternoComponent } from '../altera-status-interno/altera-status-interno.component';


@Component({
  selector: 'ngx-atendimento-solicitacao',
  templateUrl: './atendimento-solicitacao.component.html',
  styleUrls: ['./atendimento-solicitacao.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class AtendimentoSolicitacaoComponent implements OnInit, AfterViewInit {

  public gerandoRelatorio: boolean = false;
  public permissao;
  public formulario: FormGroup;
  public EquipesParticipantes;

  visualizacao = false
  idAtendimento
  nomeEmpresaVisualizacao

  usuario = this.loginService.getUsuarioDadosCompletos()
  public departamentosUsuario = [];
  aparecerSpinner1
  ContatoCliente = false
  public idCliente;
  public nomeCliente;
  public Parametros = []
  public disableAta: boolean = true
  selectDepartamentoMexido = false

  tamanhoPagina

  verAdicionarAnotacao = false
  verAdicionarJustificativa = false

  idUsuarioAtribuido = 0
  public idTipoServicoInicial = 0;

  public ListaExclusao: object[];
  idTabela = 1;

  CheckboxDisable: boolean = true;
  Equipes;
  public VerificaDepartamento;


  public escreverContato = false;
  public flagDetalhe = false;

  public componentePai;
  public botaoGravar = false;
  public colunasAnotacao = ['Data', 'Usuario', 'Anotacao', 'idTabela'];
  public colunasDependencia = ['idSolicitacao', 'Departamento', 'FilialFocus', 'TipoServico', 'Responsavel', 'Prazo', 'Status']
  public colunaNomeArquivo: string[] = ['nome'];
  public dadosAnotacao = []
  public dadosDependencia = []

  public Departamentos: any = []
  public Empresas: any = []
  public TipoServicos: any = []
  public Filiais: any = []
  public ContatosCliente: any = []

  public contentType: string = "";

  public larguraPagina

  public Prioridade = [
    { value: 'Urgente', viewValue: 'Urgente' },
    { value: 'Alta', viewValue: 'Alta' },
    { value: 'Normal', viewValue: 'Normal' },
    { value: 'Baixo', viewValue: 'Baixo' }
  ]
  public Natureza = [
    { value: 'Solicitação', viewValue: 'Solicitação' },
    { value: 'Reclamação', viewValue: 'Reclamação' },
    { value: 'Elogio', viewValue: 'Elogio' },
    { value: 'FeedBack', viewValue: 'FeedBack' }
  ]

  private DadosRecebidos: any;
  private ListaArquivos: any[];
  private ListaArquivosUpload: any[] = [];
  iconesPersonalizados = personalizedIcons
  usuarioLogado
  estado: string = ''
  injecaoDados


  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AtendimentoSolicitacaoComponent>,
    public dialog: MatDialog,
    private atendimentoSolicitacaoService: AtendimentoSolicitacaoService,
    private clienteService: ClienteService,
    private usuarioService: UsuarioService,
    public uploadService: UploadAtendimentoService,
    public equipeService: EquipeService,
    private apiConsultaSolicitacoes: ConsultaSolicitacoesService,
    public ataReuniaoService: AtaReuniaoService,
    public arquivoService: ArquivoService,
    public chatService: ChatService,
    public iconLibraries: NbIconLibraries,
    private parametrosService: ParametrosService,
    private loginService: LoginService,
    private ngZone: NgZone) {

    this.estado = 'carregando'

    console.log(this.estado)
    this.injecaoDados = data

    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos();

    this.iconLibraries.registerSvgPack('personalized', {
      'pdf': this.iconesPersonalizados.pdf,
      'excel': this.iconesPersonalizados.excel,
      'word': this.iconesPersonalizados.word,
      'audio': this.iconesPersonalizados.audio,
      'image': this.iconesPersonalizados.image,
      'video': this.iconesPersonalizados.video,
      'padrao': this.iconesPersonalizados.padrao,
    })
    this.iconLibraries.setDefaultPack('personalized')

    this.larguraPagina = document.documentElement.clientWidth

    this.formulario = this.formBuilder.group({
      Status: [""],
      CanalSolicitacao: [null, [Validators.required]],
      Departamento: [null, [Validators.required]],
      Prioridade: [null, [Validators.required]],
      NaturezaAtendimento: [null, [Validators.required]],
      PrazoInterno: [null],
      PrazoExterno: [null],
      TipoServico: [null, [Validators.required]],
      Empresa: [null, [Validators.required]],
      FilialFocus: [null, [Validators.required]],
      RetornoCliente: [null],
      DataIdentificacao: [null, [FormValidations.dataIgualAnterior]],
      Solicitacao: [null, [Validators.required]],
      UsuarioAtribuido: [null],
      Tarefa: [null],
      CanalRetorno: [null],
      UsuarioRelator: [null],
      DataCadastro: [null],
      NomeCliente: [null],
      DepartamentoOrigem: [null],

      StatusAtendido: [null],

      Id: [0],
      idUsuarioAtribuido: [0],
      idTarefa: [0],
      idAtendimento: [0],
      idTipoServico: [0],
      idEmpresa: [0, [Validators.required]],
      idFilialFocus: [0],
      idSolicitacaoMaster: [0],
      idUsuarioRelator: [0],
      idTabela: [null],
      SolicitacaoInterna: [null],

      ListaHistorico: this.formBuilder.array([]),
      ListaSolicitacaoDependente: this.formBuilder.array([]),
      ListaAnexo: this.formBuilder.array([])
    })

    if (data.componentePai == 'Atendimento') {
      this.formulario.patchValue({
        CanalSolicitacao: data.CanalSolicitacao
      })
    }



  }

  ngOnInit(): void {
    this.RetornaEquipesParticipantes();
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(async () => {
      this.permissao = this.loginService.getPermissaoComponente("Cadastro", "Atendimento");

      await this.atendimentoSolicitacaoService.getDepartamentos().then(r => this.montarDepartamentosSelect(r));
      await this.clienteService.getFiliais().then(r => this.montarFiliaisSelect(r));

      this.insereDadosComponentePai(this.injecaoDados);
      this.insereUsuarioRelator(this.injecaoDados);
      this.insereContatoCliente(this.injecaoDados);
      this.FormataCNPJ();

      if (this.injecaoDados.dados) {
        const dados = this.injecaoDados.dados;
        await this.verificaAta(dados.idAtendimento);
        await this.atendimentoSolicitacaoService.getDepartamentos().then(() => {
          this.montarTipoServicoSelect(dados.Departamento);
        });
        this.insereDadosFormulario(dados);
        this.idUsuarioAtribuido = dados.idUsuarioAtribuido;
        this.ListaArquivos = dados.ListaAnexo;

        if (this.visualizacao) {
          this.setaCNPJEmpresa();
        }
      }

      if (this.injecaoDados) {
        this.flagDetalhe = this.injecaoDados.flagDetalhe;
      }

      this.formulario.value.idTarefa = 0;
      this.DadosRecebidos = this.injecaoDados.dados;
      this.verificaUsuarioLogadoRelator();

      if (this.permissao < 2) {
        this.formulario.disable();
      }

      // ✅ Atualiza o estado depois que o Angular terminar o ciclo
      setTimeout(() => {
        this.ngZone.run(() => {
          this.estado = 'sucesso';
        });
      });
    });
  }

  //#region Métodos de regras da checkbox
  async RetornaEquipesParticipantes() {

    await this.equipeService.getAll()
      .toPromise()
      .then((response: any) => this.Equipes = response)

    this.EquipesParticipantes = this.Equipes.filter(x => x.ListaColaborador
      .map(j => j.idUsuario)
      .includes(this.usuario.Id)
    )

  }

  public verificaDepartamentoUsuario() {
    this.VerificaDepartamento = this.EquipesParticipantes.map(c => c.Departamento)
      .includes(this.formulario.value.Departamento)
  }

  public async CheckboxStatusMomento() {
    this.verificaDepartamentoUsuario()

    if (this.VerificaDepartamento == true) {

      this.CheckboxDisable = false

    }
    if (this.VerificaDepartamento == false) {

      this.CheckboxDisable = true
      this.formulario.patchValue({
        StatusAtendido: false
      })
    }
  }

  public StatusCheckbox() {
    if (this.formulario.value.StatusAtendido == true) {
      this.formulario.patchValue({
        StatusAtendido: 1,
      })
      this.formulario.value.StatusAtendido = 1
    }
    else {
      this.formulario.patchValue({
        StatusAtendido: 0
      })
    }

  }

  //#region Métodos de montagem de campos select

  public montarDepartamentosSelect(departamentos) {
    departamentos.forEach(departamento => {
      this.Departamentos.push({ value: departamento.Nome, viewValue: departamento.Nome, Id: departamento.Id })
    })
    this.Departamentos.sort((a, b) => {

      if (a.viewValue > b.viewValue) {
        return 1;
      }

      if (a.viewValue < b.viewValue) {
        return -1;
      }

      return 0;

    });
  }

  public async montarTipoServicoSelect(departamento) {

    let idDepartamento;
    this.TipoServicos = []

    if (this.selectDepartamentoMexido == true) {
      this.formulario.patchValue({
        TipoServico: "",
        idTipoServico: 0
      })
    } else {
      this.selectDepartamentoMexido = true
    }

    await this.Departamentos.forEach(linha => {
      if (linha.value == departamento) {
        idDepartamento = linha.Id
      }
    })

    await this.atendimentoSolicitacaoService.getTipoServico(idDepartamento)
      .then(
        response => {
          response.forEach(linha => {
            this.TipoServicos.push({ value: linha.Descricao, viewValue: linha.Descricao, Id: linha.Id })
          })
        }
      )

    this.TipoServicos.sort((a, b) => {

      if (a.value > b.value) {
        return 1;
      }

      if (a.value < b.value) {
        return -1;
      }

      return 0;

    });
    this.CheckboxStatusMomento();

  }

  public montarFiliaisSelect(filiais) {
    filiais.forEach(filial => {
      this.Filiais.push({ value: filial.NomeFilial, viewValue: `${filial.UF}-${filial.NomeFilial}`, Id: filial.Id })
    })

  }

  //#endregion

  //#region Métodos de inserção de dados no formulario

  // SETA O ID DO TIPO DE SERVIÇO ESCOLHIDO NO SELECT NA VARIÁVEL DO FORMULÁRIO
  setarIdTipoServico(elemento) {
    this.TipoServicos.forEach(linha => {
      if (linha.value == elemento.value) {
        this.formulario.patchValue({
          idTipoServico: linha.Id
        })
      }
    })
  }

  // SETA O ID DA EMPRESA ESCOLHIDA NO SELECT NA VARIÁVEL DO FORMULÁRIO
  setarIdEmpresa(evento) {
    this.formulario.patchValue({
      Empresa: this.Empresas.filter(empresa => empresa.Id == evento.value)[0].RazaoSocial
    })
  }

  // SETA O CNPJ DA EMPRESA NO CAMPO EMPRESA CASO ESTEJA EM VISUALIZAÇÃO
  setaCNPJEmpresa() {
    this.nomeEmpresaVisualizacao = this.formulario.get('Empresa').value
    let cnpj

    this.Empresas.forEach(linha => {

      if (linha.Id == this.formulario.get('idEmpresa').value) {
        cnpj = linha.CNPJ
      }
    })

    this.formulario.patchValue({
      Empresa: `${FormValidations.formatarCampo(cnpj, 'cnpj')} - ${this.nomeEmpresaVisualizacao}`
    })
  }

  //#endregion

  // PEGA O ID DA FILIAL SELECIONADA
  pegarIdFilial(filial) {
    this.Filiais.forEach(linha => {
      if (linha.value == filial) {
        this.formulario.patchValue({
          idFilialFocus: linha.Id
        })
      }
    })
  }


  //#region Métodos relacionados ao Histórico

  // PREENCHE A TABELA DE HISTÓRICO
  preencherTabelaHistorico(lista) {

    lista.forEach(linha => {
      linha.DataCadastro = FormValidations.retiraMilesimos(linha.DataCadastro)
    })


    lista.forEach(linha => {
      this.dadosAnotacao.push(
        {
          Id: linha.Id,
          idUsuario: linha.idUsuario,
          Descricao: linha.Descricao,
          Usuario: linha.Usuario,
          DataCadastro: linha.DataCadastro,
          Solucao: linha.Solucao,
          idTabela: this.idTabela++
        }
      )
    })

    this.dadosAnotacao = [...this.dadosAnotacao]
  }

  // CRIA E RETORNA UM CONTROL QUE SERÁ ADICIONADO AO FORMULARIO
  criarHistoricoGroupForm() {
    return this.formBuilder.group({
      Id: [null],
      idUsuario: [null],
      Descricao: [null],
      Usuario: [null],
      DataCadastro: [null],
      Solucao: [null]
    })
  }

  // RECEBE OS DADOS DA TABELA DE CONTATO E OS INSERE NO FORMULARIO CONTATOEMPRESAS
  carregarHistorico() {

    let AnotacoesFormArray = this.formulario.get('ListaHistorico') as FormArray

    this.dadosAnotacao.forEach(() => {
      AnotacoesFormArray.push(this.criarHistoricoGroupForm())
    })

    this.formulario.controls.ListaHistorico.patchValue([])
    this.formulario.controls.ListaHistorico.patchValue(this.dadosAnotacao)

  }

  // EXCLUI UMA ANOTAÇÃO DA TABELA
  excluirHistoricoTabela(anotacao) {

    for (let i = 0; i <= this.dadosAnotacao.length; i++) {

      if (this.dadosAnotacao[i].idTabela == anotacao.idTabela) {
        this.dadosAnotacao.splice(i, 1)
        break;
      }

    }
    this.reorganizarTabela()
    this.dadosAnotacao = [...this.dadosAnotacao]

  }

  // MÉTODO ADICIONA A TABELA UMA NOVA ANOTAÇÃO
  adicionarHistorico(anotacao) {

    var dt = new Date();

    let usuario = this.loginService.getUsuarioDadosCompletos()

    let novaAnotacao = {}

    novaAnotacao['Id'] = 0
    novaAnotacao['idUsuario'] = this.usuario.Id
    novaAnotacao['Descricao'] = anotacao
    novaAnotacao['Usuario'] = usuario.Nome
    novaAnotacao['DataCadastro'] = FormValidations.criarDataAMD()
    novaAnotacao['Solucao'] = "N"

    this.dadosAnotacao.push(novaAnotacao)
    this.dadosAnotacao = [...this.dadosAnotacao]

    this.mostrarAdicionarAnotacao()
  }

  adicionarHistoricoJustificativa(anotacao) {

    let novaAnotacao = {}

    novaAnotacao['Id'] = anotacao.Id
    novaAnotacao['idUsuario'] = anotacao.idUsuario
    novaAnotacao['Descricao'] = anotacao.Descricao
    novaAnotacao['Usuario'] = this.formulario.get('UsuarioRelator').value
    novaAnotacao['DataCadastro'] = FormValidations.criarDataAMD()
    novaAnotacao['Solucao'] = anotacao.Solucao

    this.dadosAnotacao.push(novaAnotacao)
    this.dadosAnotacao = [...this.dadosAnotacao]
  }

  //#endregion


  //#region Métodos relacionados a Solicitações Dependentes

  preencherTabelaDependencia(lista) {
    lista.forEach(linha => {
      this.dadosDependencia.push(
        {
          idSolicitacao: linha.idSolicitacao,
          idFilialFocus: linha.idFilialFocus,
          idTipoServico: linha.idTipoServico,
          idResponsavel: linha.idResponsavel,
          idDepartamento: linha.idDepartamento,
          Departamento: linha.Departamento,
          FilialFocus: linha.FilialFocus,
          TipoServico: linha.TipoServico,
          Responsavel: linha.Responsavel,
          Prazo: linha.Prazo,
          Status: linha.Status,
          Solicitacao: linha.Solicitacao
        }
      )
    })
  }

  criarDependenciaGroupForm() {
    return this.formBuilder.group({
      idSolicitacao: [0],
      idFilialFocus: [0],
      idTipoServico: [0],
      idResponsavel: [0],
      idDepartamento: [0],
      Departamento: [null],
      FilialFocus: [null],
      TipoServico: [null],
      Responsavel: [null],
      Prazo: [null],
      Status: [null],
      Solicitacao: [null]
    })
  }

  carregarDependencia() {

    let DependenciaFormArray = this.formulario.get('ListaSolicitacaoDependente') as FormArray

    this.dadosDependencia.forEach(() => {
      DependenciaFormArray.push(this.criarDependenciaGroupForm())
    })

    this.formulario.controls.ListaSolicitacaoDependente.patchValue(this.dadosDependencia)

  }

  adicionarDependencia() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data

    this.dialog.open(AtendimentoDependenciaComponent, dialogConfig).afterClosed().subscribe(
      response => {

        if (response) {

          let dependencia = {
            idSolicitacao: response.idSolicitacao,
            idFilialFocus: response.idFilialFocus,
            idTipoServico: response.idTipoServico,
            idResponsavel: response.idResponsavel,
            idDepartamento: response.idDepartamento,
            Departamento: response.Departamento,
            FilialFocus: response.FilialFocus,
            TipoServico: response.TipoServico,
            Responsavel: response.Responsavel,
            Prazo: response.Prazo,
            Status: response.Status,
            Solicitacao: response.Solicitacao
          }

          this.dadosDependencia.push(dependencia)

          this.dadosDependencia = [...this.dadosDependencia]

        }
      }
    )
  }

  procurarDependencia(obj) {

    let resposta = {
      pesquisar: false,
      solicitacao: obj.idSolicitacao
    }

    this.dialogRef.close(resposta)
  }

  //#endregion


  recriarFormGroup() {
    this.formulario.removeControl('ListaHistorico')
    this.formulario.removeControl('ListaSolicitacaoDependente')

    this.formulario.addControl('ListaHistorico', this.formBuilder.array([]))
    this.formulario.addControl('ListaSolicitacaoDependente', this.formBuilder.array([]))
  }



  // REORGANIZA OS IDS DA TABELA
  reorganizarTabela() {
    let id = 1
    this.dadosAnotacao.forEach(linha => linha.idTabela = id++)
  }

  // RETIRA O CAMPO IDTABELA DA LISTA
  retirarIdTabela() {

    this.dadosAnotacao.forEach(linha => {
      delete linha.idTabela
    })
  }

  //#region Métidos de formatação de data

  formatarDataGravacao() {

    if (this.formulario.get('Id').value == 0) {

      this.formulario.patchValue({
        PrazoInterno: '0001-01-01T00:00:00'
      })


      this.formulario.patchValue({
        PrazoExterno: '0001-01-01T00:00:00'
      })

    }

    if (this.formulario.get('DataIdentificacao').value) {
      this.formulario.patchValue({
        DataIdentificacao: FormValidations.criarDataAPI(this.formulario.get('DataIdentificacao').value)
      })
    }


  }

  formatarDataHistorico() {
    this.dadosAnotacao.forEach(
      linha => {
        linha.DataCadastro = FormValidations.formatarDataHoraAPI(linha.DataCadastro)
      }
    )
  }

  formatarDataDependencia() {
    this.dadosDependencia.forEach(linha => {
      linha.Prazo = `${FormValidations.formatarCampo(linha.Prazo, "dataDMAtoAMD")}T00:00:00`
    })
  }

  //#endregion

  //#region Métodos relacionados a usuário

  procurarUsuario() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      componente: "Usuario"
    }

    this.dialog.open(PesquisaComponent, dialogConfig).afterClosed()
      .subscribe(
        response => {

          if (response) {
            this.formulario.patchValue({
              UsuarioAtribuido: response.Nome,
              idUsuarioAtribuido: response.Id
            })
          }

        }
      )
  }

  apagarUsuario() {
    this.formulario.patchValue({
      idUsuarioAtribuido: 0,
      UsuarioAtribuido: null
    })
  }

  public insereUsuarioRelator(data) {
    if (data.idUsuarioRelator) {
      this.formulario.patchValue({
        UsuarioRelator: data.UsuarioRelator.Nome,
        idUsuarioRelator: data.UsuarioRelator.Id
      })
    }

  }

  retornarUsuarioRelator() {
    let id = this.formulario.get('idUsuarioRelator').value
  }

  //#endregion


  // APAGA O CAMPO RETORNOCLIENTE E OCULTA O BOTÃO DE APAGAR
  apagarContatoCliente() {
    this.ContatoCliente = false

    this.formulario.patchValue({
      RetornoCliente: null
    })
  }

  // INSERE A DATA E HORA DE CADASTRO DESTA SOLICITAÇÃO
  insereDataCadastro() {
    if (this.formulario.get('Id').value == 0) {
      this.formulario.patchValue({
        DataCadastro: FormValidations.criarDataAPI()
      })
    }
  }

  metodosGravacao() {

    this.formulario.patchValue({
      DataCadastro: FormValidations.formatarDataHoraAPI(this.formulario.get("DataCadastro").value)
    })
    this.StatusCheckbox()
    this.formatarDataGravacao()
    this.insereDataCadastro()
    this.retirarIdTabela()
    // this.formatarDataHistorico()
    // this.formatarDataGravacao()
    // this.formatarDataDependencia()
    // this.carregarHistorico()
    // this.carregarDependencia()


  }

  // MÉTODO FECHA A JANELA E ENVIA PARA O COMPONENTE QUE O CHAMOU A SOLICITAÇÃO
  async adicionarSolicitacao() {


    if (this.formulario.value.Id == 0) {
      await this.VerificaSolicitacaoAtendida();
    }

    this.metodosGravacao();

    this.formulario.value.ListaAnexo = this.ListaArquivos ? this.ListaArquivos : [];
    this.formulario.value.ListaHistorico = this.dadosAnotacao;
    this.formulario.value.ListaSolicitacaoDependente = this.dadosDependencia;

    this.dialogRef.close(this.formulario.value)

  }

  gravarSolicitacao() {
    this.metodosGravacao()
    this.botaoGravar = true

    this.formulario.value.ListaAnexo = this.ListaArquivos ? this.ListaArquivos : []
    this.formulario.value.ListaHistorico = this.dadosAnotacao;
    this.formulario.value.ListaSolicitacaoDependente = this.dadosDependencia;
    this.atendimentoSolicitacaoService.gravaAPI(this.formulario.value).then(
      response => {

        this.recriarFormGroup()
        this.abrirPaginaErro(response, "sistema")
      }
    )

    let resposta = {
      pesquisar: true
    }

    this.dialogRef.close(resposta)
  }

  // FECHA A PÁGINA
  fecharPagina() {

    if (this.formulario.get('Status').value == 'Atendido') {
      this.dialogRef.close()

    } else {

      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = `Tem certeza que deseja fechar? Os dados serão perdidos`

      if (this.formulario.dirty) {

        this.dialog.open(PaginaPerguntaComponent, dialogConfig).afterClosed()
          .subscribe(
            response => {
              if (response) {
                if (this.componentePai == "Atendimento") {
                  this.dialogRef.close();
                } else {
                  this.dialogRef.close({ pesquisar: false })
                }
              }
            }
          )

      } else {
        if (this.componentePai == "Atendimento") {
          this.dialogRef.close();
        } else {
          this.dialogRef.close({ pesquisar: false })
        }
      }

    }

  }

  // MÉTODO PARA MOSTRAR O CAMPO DE ANOTAÇÃO
  mostrarAdicionarAnotacao(justificativa?) {

    this.verAdicionarAnotacao = !this.verAdicionarAnotacao

    if (justificativa) {
      this.verAdicionarJustificativa = !this.verAdicionarJustificativa
    }
  }

  // VERIFICA SE POSSUI ANOTAÇÃO
  verificaAnotacao(anotacao) {
    if (anotacao && anotacao != "") {
      return false
    }

    return true
  }

  devolverSolicitacao(justificativa) {

    let idSolicitacao = this.formulario.get('Id').value
    let idTarefa = this.formulario.get('idTarefa').value

    let devolver = { idSolicitacao: idSolicitacao, Justificativa: justificativa, idTarefa: idTarefa }

    this.mostrarAdicionarAnotacao(true)

    this.atendimentoSolicitacaoService.devolverRelator(devolver)
      .then(
        response => {
          this.formulario.patchValue({
            idUsuarioAtribuido: this.formulario.get('idUsuarioRelator').value,
            UsuarioAtribuido: this.formulario.get('UsuarioRelator').value,
          })

          this.adicionarHistoricoJustificativa(response)

          if (this.componentePai == "Atendimento") {
            this.adicionarSolicitacao()
          }

          this.dialogRef.close({ pesquisar: true })

          this.abrirPaginaErro("Operação realizada com sucesso!", "interno")
        }
      )

      .catch(
        error => {
          this.abrirPaginaErro(error, "erro")
        }
      )

  }

  abrirPaginaErro(mensagem, tipo) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      mensagem: mensagem,
      tipo: tipo
    };
    this.dialog.open(PaginaErroComponent, dialogConfig);
  }

  procurarSolicitacaoOriginal() {

    let resposta = {
      pesquisar: false,
      solicitacao: this.formulario.get('idSolicitacaoMaster').value
    }

    this.dialogRef.close(resposta)
  }

  inserirContato() {
    this.escreverContato = !this.escreverContato

    this.formulario.patchValue({
      RetornoCliente: null
    })
  }

  public insereContatoCliente(data) {
    if (data.ContatoCliente) {
      this.ContatoCliente = true
      this.formulario.patchValue({
        RetornoCliente: data.ContatoCliente
      })
      this.escreverContato = true
    }
  }

  public insereDadosFormulario(dados) {

    this.formulario.patchValue({

      Id: dados.Id,
      idAtendimento: dados.idAtendimento,
      idSolicitacaoMaster: dados.idSolicitacaoMaster,
      CanalSolicitacao: dados.CanalSolicitacao,
      SolicitacaoInterna: dados.SolicitacaoInterna,
      Status: dados.Status,
      Departamento: dados.Departamento,
      DepartamentoOrigem: dados.DepartamentoOrigem,
      Prioridade: dados.Prioridade,
      NaturezaAtendimento: dados.NaturezaAtendimento,
      PrazoInterno: FormValidations.retirarFormatacaoDataHora(dados.PrazoInterno),
      PrazoExterno: FormValidations.retirarFormatacaoDataHora(dados.PrazoExterno),
      idTipoServico: dados.idTipoServico,
      TipoServico: dados.TipoServico,
      idEmpresa: dados.idEmpresa,
      Empresa: dados.Empresa,
      NomeCliente: dados.NomeCliente,
      idCliente: dados.idCliente,
      RetornoCliente: dados.RetornoCliente,
      DataIdentificacao: FormValidations.retirarFormatacaoDataHora(dados.DataIdentificacao),
      Solicitacao: dados.Solicitacao,
      idUsuarioAtribuido: dados.idUsuarioAtribuido,
      UsuarioAtribuido: dados.UsuarioAtribuido,
      idTarefa: dados.idTarefa,
      Tarefa: dados.Tarefa,
      CanalRetorno: dados.CanalRetorno,
      idTabela: dados.idTabela,
      idFilialFocus: dados.idFilialFocus,
      FilialFocus: dados.FilialFocus,
      UsuarioRelator: dados.UsuarioRelator,
      idUsuarioRelator: dados.idUsuarioRelator,
      DataCadastro: FormValidations.formatarDataHoraAPI(dados.DataCadastro),
    })

    if (this.formulario.value.Id == 0) {
      this.formulario.patchValue({
        ListaAnexo: this.ListaArquivosUpload
      })
    }
    this.preencherTabelaHistorico(dados.ListaHistorico)

    this.preencherTabelaDependencia(dados.ListaSolicitacaoDependente)

    this.idTipoServicoInicial = this.formulario.value.idTipoServico

  }

  public insereDadosComponentePai(data) {

    this.componentePai = data.componentePai
    this.departamentosUsuario = data.departamentosUsuario ? data.departamentosUsuario : []
    this.Empresas = data.ListaEmpresas
    this.ContatosCliente = data.ListaContatos

    // CASO O COMPONENTE SEJA CHAMADO PELA TELA DE CONSULTA
    if (data.visualizacao) {
      this.visualizacao = data.visualizacao
      this.idAtendimento = data.idAtendimento
    }

    if (data.idCliente) {
      this.idCliente = data.idCliente;
    }
    if (data.NomeCliente) {
      this.nomeCliente = data.NomeCliente
    }

  }

  verificarInserirContato(valor) {
    if (valor == 0) {
      this.inserirContato()
    }
  }

  public FormataCNPJ() {

    this.Empresas.forEach(linha => {
      linha.CNPJ = FormValidations.formatarCampo(linha.CNPJ, 'cnpj');
    })

  }


  //#region Métodos relacionados a arquivos

  AbrirCaixaArquivos() {
    document.getElementById('CaixaArquivos').click();
  }

  async ArquivosSelecionados(arquivos: any) {
    await this.CriarObjetoUpload(arquivos);
    if (this.formulario.value.Id != 0) {
      this.EnviarArquivo();
    }
  }


  async CriarObjetoUpload(listaAnexo: FileList) {
    for (let i = 0; i < listaAnexo.length; i++) {
      let lerArquivo: FileReader = new FileReader();

      lerArquivo.onload = (x) => {
        this.contentType = '';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 3, listaAnexo[i].name.length) == 'pdf' || 'PDF') this.contentType = 'application/pdf';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 3, listaAnexo[i].name.length) == 'xls') this.contentType = 'application/xls';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 4, listaAnexo[i].name.length) == 'xlsx') this.contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 3, listaAnexo[i].name.length) == 'txt') this.contentType = 'text/plain';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 3, listaAnexo[i].name.length) == 'csv') this.contentType = 'application/octet-stream';
        if (listaAnexo[i].name.substring(listaAnexo[i].name.length - 4, listaAnexo[i].name.length) == 'docx') this.contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

        if (this.contentType != '') {
          if (this.DadosRecebidos != undefined) {
            this.ListaArquivosUpload.push({
              idTarefaSolicitacao: this.DadosRecebidos['idTarefa'] || 0,
              idUsuario: this.usuario.Id,
              NomeArquivo: listaAnexo[i].name,
              DataInclusao: new Date(Date.now()).toISOString().split('.')[0],
              contentType: this.contentType,
              Base64String: btoa(lerArquivo.result.toString()),
            });
          }
          else {
            this.ListaArquivosUpload.push({
              idTarefaSolicitacao: 0,
              idUsuario: this.usuario.Id,
              NomeArquivo: listaAnexo[i].name,
              DataInclusao: new Date(Date.now()).toISOString().split('.')[0],
              contentType: this.contentType,
              Base64String: btoa(lerArquivo.result.toString()),
            });
          }
        }
        else {
          this.abrirPaginaErro('O formato do arquivo não é aceito', 'interno');
        }
        this.montaListaAnexo(this.ListaArquivosUpload)
      }
      lerArquivo.readAsBinaryString(listaAnexo[i])


    }
  }
  montaListaAnexo(lista) {

    if (this.formulario.value.Id == 0) {
      this.ListaArquivos = lista

      this.ListaArquivos = [...this.ListaArquivos]
    }
  }

  EnviarArquivo() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = `Enviando arquivo.`

    let dialogoEspera = this.dialog.open(PaginaEsperaComponent, dialogConfig);
    dialogoEspera.afterOpened().subscribe(() => {

      this.uploadService.EnviarArquivo(this.ListaArquivosUpload).then(resposta => {

        if (this.DadosRecebidos == undefined) {
          resposta.forEach(arquivo => {
            this.ListaArquivos.push({
              idUsuario: this.usuario.Id,
              idTarefaSolicitacao: 0,
              Usuario: this.usuario.Nome,
              DataInclusao: new Date(Date.now()).toISOString().split('.')[0],
              PathArquivo: arquivo.pathArquivo,
              NomeArquivo: arquivo.nomeArquivo,
              Base64String: null,
              ConteudoArquivo: null,
              ContentType: null,
              Id: arquivo.id
            });
          });
        } else {
          resposta.forEach(arquivo => {

            this.ListaArquivos.push({
              idUsuario: this.usuario.Id,
              idTarefaSolicitacao: this.DadosRecebidos['idTarefa'],
              Usuario: this.usuario.Nome,
              DataInclusao: new Date(Date.now()).toISOString().split('.')[0],
              PathArquivo: arquivo.pathArquivo,
              NomeArquivo: arquivo.nomeArquivo,
              Base64String: null,
              ConteudoArquivo: null,
              ContentType: null,
              Id: arquivo.id
            });
          });
        }
        this.ListaArquivos = [...this.ListaArquivos];
        this.ListaArquivosUpload = []
        dialogoEspera.close();
      }).catch(erro => {
        throw new Error(erro);

      });
    });

  }

  ExcluirArquivo(arquivoSelecionado, i) {

    if (this.formulario.value.Id != 0) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = `Tem certeza que deseja excluir o arquivo selecionado?`

      this.dialog.open(PaginaPerguntaComponent, dialogConfig).afterClosed()
        .subscribe(
          response => {
            if (!response) return;
            else {
              const DELETAR_ARQUIVO = {
                Id: arquivoSelecionado.Id,
                NomeArquivo: arquivoSelecionado.NomeArquivo,
                PathArquivo: arquivoSelecionado.PathArquivo,
              }
              var novaListaArquivos: any[] = [];

              dialogConfig.data = `Excluíndo arquivo selecionado.`
              let dialogoEspera = this.dialog.open(PaginaEsperaComponent, dialogConfig);
              dialogoEspera.afterOpened().subscribe(() => {
                this.uploadService.DeletarArquivo(DELETAR_ARQUIVO).then((resposta) => {
                  this.ListaArquivos.forEach(arquivo => {
                    if (DELETAR_ARQUIVO.Id != arquivo.Id) {
                      novaListaArquivos.push(arquivo);
                    }
                  })
                  this.ListaArquivos = novaListaArquivos;
                  this.ListaArquivos = [...this.ListaArquivos];
                  dialogoEspera.close();
                })
                  .catch(
                    error => {
                    }
                  )
              });
            }
          }
        )
    }
    else {
      this.ListaArquivosUpload.splice(i, 1)
      this.ListaArquivosUpload = [...this.ListaArquivosUpload];
      this.ListaArquivos.splice(i, 1)
      this.ListaArquivos = [...this.ListaArquivos]
    }
  }

  DownloadArquivo(arquivoSelecionado) {
    let arquivo = arquivoSelecionado.NomeArquivo;
    if (arquivo.substring(arquivo.length - 3, arquivo.length) == 'pdf') this.contentType = 'application/pdf';
    if (arquivo.substring(arquivo.length - 3, arquivo.length) == 'xls') this.contentType = 'application/xls';
    if (arquivo.substring(arquivo.length - 4, arquivo.length) == 'xlsx') this.contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (arquivo.substring(arquivo.length - 4, arquivo.length) == 'docx') this.contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';


    this.uploadService.ReceberArquivo(arquivoSelecionado.PathArquivo).then(resposta => {
      let blob = new Blob([resposta], { type: this.contentType });
      const fileName = arquivoSelecionado.NomeArquivo;
      const a = document.createElement('a');
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }).catch(erro => {

    })
  }

  //#endregion


  public retornaDataDMA(data) {
    return FormValidations.formatarDataHoraAPI(data)
  }

  public verificaDepartamentosUsuarioSolicitacao() {

    let dptSolicitacao = this.formulario.get('Departamento').value

    for (let i = 0; i < this.departamentosUsuario.length; i++) {

      if (this.departamentosUsuario[i] == dptSolicitacao) {
        return true;
      }
    }
    return false;

  }

  public verificaUsuarioLogadoRelator() {

    if (this.formulario.value.Id != 0) {
      if (this.usuario.Id == this.formulario.value.idUsuarioRelator) {
        return true;
      }
    }

    if (this.formulario.value.Id == 0) {
      return true;
    }

    return false;

  }

  public habilitaBotoesAdicao() {

    if (this.verificaDepartamentosUsuarioSolicitacao() || this.verificaUsuarioLogadoRelator()) {

      if (this.formulario.value.Status != 'Atendido' && this.formulario.value.Status != 'Cancelado') {
        return true
      }

    }

    return false

  }

  public ativaBotaoGravar() {

    if (this.componentePai == 'Consulta') {

      if (this.formulario.get('Status').value != 'Atendido' && this.formulario.get('Status').value != 'Cancelado') {

        if (this.verificaDepartamentosUsuarioSolicitacao() || this.formulario.value.idUsuarioAtribuido == this.usuario.Id || this.formulario.value.idUsuarioRelator == this.usuario.Id) {
          return true
        }
      }
    }
    return false;

  }

  public habilitaBotaoCancelar() {

    if (this.formulario.get('Status').value != 'Atendido' && this.formulario.get('Status').value != 'Cancelado') {
      if (this.usuario.Id == this.formulario.get('idUsuarioRelator').value) {
        if (this.usuario.Id == this.formulario.get('idUsuarioAtribuido').value) {
          return true;
        }
      }
    }

    return false
  }

  public habilitaBotaoDevolverRelator() {

    let usuarioFazParteDepartamento = false;

    this.departamentosUsuario.forEach(departamento => {
      if (departamento == this.formulario.get('Departamento').value) {
        usuarioFazParteDepartamento = true;
      }
    })

    if (this.formulario.get('idSolicitacaoMaster').value == 0 || this.formulario.get('CanalSolicitacao').value == 'Tratativa Interna Focus') {
      if (usuarioFazParteDepartamento) {

        if (this.componentePai == 'Consulta') {

          if (this.formulario.get('Status').value != 'Atendido' && this.formulario.get('Status').value != 'Cancelado') {

            if (this.formulario.get('idUsuarioAtribuido').value != this.formulario.get('idUsuarioRelator').value) {
              return true;
            }
          }
        }
      }
    }
    return false;

  }

  public cancelarSolicitacao() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = "Tem certeza que quer cancelar o atendimento?"

    let mensagem;


    this.dialog.open(PaginaPerguntaComponent, dialogConfig).afterClosed().subscribe(resposta => {
      if (resposta) {

        let objSolicitacaoCancelada = {
          DescricaoSolucao: null,
          NovoStatus: "Cancelado",
          VBAlteraResponsavel: false,
          VBAlteraStatus: true,
          idNovoUsuarioResponsavel: this.formulario.get('idUsuarioRelator').value,
          idTarefa: this.formulario.get("idTarefa").value
        }

        this.apiConsultaSolicitacoes.setAlteraStatusResposanvel(objSolicitacaoCancelada).then(
          (response) => {

            if (response.length > 0) {

              this.abrirPaginaErro(response, "sistema")

            } else {
              this.dialogRef.close({ pesquisar: true });
              this.abrirPaginaErro("Solicitação cancelada!", "interno");
            }

          }
        )

      }
    })



  }

  public confirmaFecharSolicitacao(botao?) {

    if (botao == 'fecharSolicitacao') {

      const dialogConfig = new MatDialogConfig();

      this.dialog.open(FecharSolicitacaoComponent, dialogConfig).afterClosed().subscribe(
        response => {

          if (response) this.mostrarAdicionarAnotacao(true)
        }
      )
    }
  }



  async AbrirPaginaSolucao() {

    const dialogConfig = new MatDialogConfig();

    if (this.dadosAnotacao.length > 0) {
      dialogConfig.data = this.dadosAnotacao[0].Descricao
    }

    await this.dialog.open(SolucaoTarefaComponent, dialogConfig).afterClosed().toPromise().then(
      response => {

        if (response.resposta) {

          this.formulario.patchValue({
            Status: "Atendido",
            UsuarioAtribuido: this.usuario.Nome,
            idUsuarioAtribuido: this.usuario.Id
          })
          let usuario = this.loginService.getUsuarioDadosCompletos()

          this.dadosAnotacao = []
          let novaAnotacao = {}

          novaAnotacao['Id'] = 0
          novaAnotacao['idUsuario'] = this.usuario.Id
          novaAnotacao['Descricao'] = response.texto
          novaAnotacao['Usuario'] = usuario.Nome
          novaAnotacao['DataCadastro'] = FormValidations.criarDataAMD()
          novaAnotacao['Solucao'] = "N"

          this.dadosAnotacao.push(novaAnotacao)
          this.dadosAnotacao = [...this.dadosAnotacao]
        }

      }
    )

  }

  async VerificaSolicitacaoAtendida() {

    let abrirPagina = false

    if (this.componentePai != 'Atendimento') {

      if (AtendimentoSolicitacaoService.ListaDepartamentosParticipante.includes(this.formulario.value.Departamento)) {

        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = `A solicitação já foi atendida?`

        await this.dialog.open(PaginaPerguntaComponent, dialogConfig).afterClosed().toPromise().then(

          response => {

            if (response) {
              abrirPagina = true
            } else {

              this.formulario.patchValue({
                Status: "",
                UsuarioAtribuido: "",
                idUsuarioAtribuido: 0
              })

              this.dadosAnotacao = [...[]]

            }

          })

        if (abrirPagina) {
          await this.AbrirPaginaSolucao();
        }

      }
    }
  }

  public abrirAta() {

    this.GerarRelatorio()
  }

  async GerarRelatorio() {

    this.gerandoRelatorio = true;
    await this.arquivoService.gerarRelatorio(this.Parametros, "ata de reunião").toPromise()
      .then(response => {

        this.GeraDocumento(response)
      })
      .catch(error => this.PaginaErro(error, "erro"))
    this.gerandoRelatorio = false;
  }

  public GeraDocumento(documento) {
    const dialogConfig = new MatDialogConfig();
    const blob = new Blob([documento], { type: "application/pdf" })
    const fileURL = URL.createObjectURL(blob);
    // window.open(fileURL, '_blank');

    dialogConfig.data = {
      ArquivoPDF: fileURL,
      NomeArquivo: "Relatório de Ata Reunião"
    }
    dialogConfig.panelClass = 'customDialogPdf'

    this.dialog.open(GeradorPdfComponent, dialogConfig)
  }


  public verificaAta(idAtendimento) {

    this.ataReuniaoService.getAtaSolicitacao(idAtendimento)
      .toPromise()
      .then(response => {
        if (response != 0) {
          this.disableAta = false
          this.Parametros = []
          this.Parametros.push(
            {
              Nome: 'Id',
              Valor: String(response)
            })
        }
      })
  }

  public PaginaErro(mensagem, tipo) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      mensagem: mensagem,
      tipo: tipo
    }

    this.dialog.open(PaginaErroComponent, dialogConfig)
  }

  abrirConversaWpp() {
    const dialogConfig = new MatDialogConfig()
    let conversa
    let contato = {
      NomeUsuarioWpp: this.formulario.value.RetornoCliente
    }

    this.chatService.getConversa(this.formulario.value.Id)
      .toPromise()
      .then((response: any) => {
        this.iconLibraries.registerSvgPack('personalized', {
          'pdf': this.iconesPersonalizados.pdf,
          'excel': this.iconesPersonalizados.excel,
          'word': this.iconesPersonalizados.word,
          'audio': this.iconesPersonalizados.audio,
          'image': this.iconesPersonalizados.image,
          'video': this.iconesPersonalizados.video,
          'padrao': this.iconesPersonalizados.padrao,
        })
        conversa = this.chatService.retornaChat(response.LogConversas)



        dialogConfig.data = {
          conversa: conversa,
          solicitante: contato
        }
        dialogConfig.width = '90vw'
        dialogConfig.height = '90vh'
        dialogConfig.panelClass = 'customDialogConversa'
        this.dialog.open(HistoricoConversaComponent, dialogConfig)
      })
  }

  async alteraStatus() {

    if (this.formulario.value.idUsuarioAtribuido == this.usuarioLogado.Id) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '40vw'

      dialogConfig.data = {
        idTarefa: this.formulario.value.idTarefa,
        idNovoUsuarioResponsavel: this.formulario.value.idUsuarioAtribuido,
        NovoStatus: '',
        VBAlteraStatus: true,
        VBAlteraResponsavel: false,
        DescricaoSolucao: "",
        StatusAtual: this.formulario.value.Status
      }

      this.dialog.open(AlteraStatusInternoComponent, dialogConfig)
        .afterClosed()
        .subscribe(response => {
          this.formulario.patchValue({
            Status: response
          })
        })
    }
    else {
    }
  }
}
//Alterar Status apenas caso o usuário atribuído seja o usuário logado
//Solicitação sem atribuição não pode alterar status
//Só pode atribuir a pessoas que pertencem ao departamento